<div class="loader"></div>
<p>{{text}}</p>